import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colors } from '../../../../../../../constants/colors';
import { fontSize, fontFamily } from '../../../../../../../constants/text';
import { analyticsTrackEvent } from '../../../../../../../core/analytics';
import { COPAY_MODAL_FEEDBACK_THUMBS } from '../../../../../../../core/analytics/events';

const FEEDBACK_NEGATIVE = 'down';
const FEEDBACK_POSITIVE = 'up';

const Root = styled.div.withConfig({ componentId: 'sc-uzmh6x-0' })`
  display: flex;
  justify-content: space-between;
  background-color: ${colors.theWhiteAlbum};
  padding: 25px 30px;
  box-shadow: inset 0 1px 0 0 ${colors.emptyBarGrey}, inset 0 -1px 0 0 ${colors.emptyBarGrey};
`;

const Description = styled.div.withConfig({ componentId: 'sc-uzmh6x-1' })`
  font-family: ${fontFamily.book};
  font-size: ${fontSize.mediumSmall};
  letter-spacing: 0.25px;
  color: ${colors.blueMonday};
  line-height: 20px;
  width: 50%;
`;

const ThumbContainer = styled.div.withConfig({ componentId: 'sc-uzmh6x-2' })`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 40%;
  max-width: 150px;
`;

const Thumb = styled.img.withConfig({ componentId: 'sc-uzmh6x-3' })`
  width: 20px;
  padding: 10px 20px;
  border: 1px solid ${colors.borderLine};
  border-radius: 4px;
  cursor: pointer;
`;

const handleFeedback = (action: any) =>
  analyticsTrackEvent(COPAY_MODAL_FEEDBACK_THUMBS, { action });

const Feedback = () => (
  <Root>
    <Description>Does the information on this page seem accurate?</Description>

    <ThumbContainer>
      <Thumb
        onClick={() => handleFeedback(FEEDBACK_POSITIVE)}
        src="/images/insurance/thumbs_up.svg"
      />

      <Thumb
        onClick={() => handleFeedback(FEEDBACK_NEGATIVE)}
        src="/images/insurance/thumbs_down.svg"
      />
    </ThumbContainer>
  </Root>
);

Feedback.propTypes = {
  insuranceProfile: PropTypes.object,
};

export default Feedback;
